const getMappedCustomTemplate = (state, templateId) =>
  state.customTemplates.customTemplateMap[templateId];

const getEditedTemplate = state => state.customTemplates.editedTemplate;

export default { getMappedCustomTemplate, getEditedTemplate };
